import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';
import { usePageTracking } from '../hooks/usePageTracking';
import './Contact.css';

const SUBJECT_OPTIONS = [
  'Product Question',
  'Wholesale Inquiry',
  'Collaboration',
  'Order Support',
  'Other',
];

function Contact() {
  usePageTracking('contact');
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // 'success' | 'error'

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    try {
      const apiUrl =
        process.env.REACT_APP_API_URL ||
        'https://sambas-energy-backend.onrender.com/api';

      const res = await fetch(`${apiUrl}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });

      if (res.ok) {
        setStatus('success');
        setForm({ name: '', email: '', subject: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <BrandLogo />

      {/* Back button */}
      <button className="back-button-simple" onClick={() => navigate('/about')}>
        <span className="back-text">← Back</span>
        <span className="back-arrow">←</span>
      </button>

      <div className="contact-container">
        <h1 className="contact-heading">GET IN TOUCH</h1>
        <p className="contact-subheading">
          Questions about Sambas? Wholesale? Collabs? We're listening.
        </p>

        {status === 'success' ? (
          <div className="contact-success">
            <div className="success-icon">✓</div>
            <h2>Message Sent!</h2>
            <p>We'll get back to you soon.</p>
            <button className="contact-btn" onClick={() => setStatus(null)}>
              Send Another
            </button>
          </div>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Your name"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="you@example.com"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">What's this about?</label>
              <select
                id="subject"
                name="subject"
                value={form.subject}
                onChange={handleChange}
                required
              >
                <option value="" disabled>
                  Select a topic
                </option>
                {SUBJECT_OPTIONS.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                placeholder="Tell us what's on your mind..."
                rows="5"
                value={form.message}
                onChange={handleChange}
                required
              />
            </div>

            {status === 'error' && (
              <p className="contact-error">Something went wrong. Please try again.</p>
            )}

            <button type="submit" className="contact-btn" disabled={loading}>
              {loading ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default Contact;
